import clsx from 'clsx'
import { XMarkIcon } from 'components/icons/Icons'
import { NsKey } from 'enums/NsKey'
import { useTranslation } from 'react-i18next'
import { DialogDescription, DialogTitle } from './Dialog'

export interface DialogHeaderProps {
  title: string
  description?: string
  onClose: () => void
}

const DialogHeader: React.FC<DialogHeaderProps> = ({
  title,
  description,
  onClose
}) => {
  const { t } = useTranslation(NsKey.Common)

  return (
    <div className="relative flex items-start justify-between">
      <div>
        <DialogTitle className="text-balance text-lg/6 font-semibold text-zinc-950 sm:text-xl/6">
          {t(title)}
        </DialogTitle>
        {description && (
          <DialogDescription
            className={clsx("mt-2 text-pretty")}
          >
            {description}
          </DialogDescription>
        )}
      </div>
      <div className="ml-3 flex h-7 items-center">
        <button
          type="button"
          onClick={onClose}
          className="relative rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-primary"
        >
          <span className="absolute -inset-2.5" />
          <span className="sr-only">Close dialog</span>
          <XMarkIcon aria-hidden="true" className="size-6" />
        </button>
      </div>
    </div>
  )
}

export default DialogHeader
